import { render, staticRenderFns } from "./AdminReportForm.vue?vue&type=template&id=4a373d74&scoped=true"
import script from "./AdminReportForm.vue?vue&type=script&lang=js"
export * from "./AdminReportForm.vue?vue&type=script&lang=js"
import style0 from "./AdminReportForm.vue?vue&type=style&index=0&id=4a373d74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a373d74",
  null
  
)

export default component.exports